//--sound
import { SoundProvider, useSound } from '../components/sound/soundContext';

import React, { useState, useRef, useCallback, useEffect } from 'react';
import Draggable from 'react-draggable';
import BackButton from './back';
import PropTypes from 'prop-types';
import { themePropType } from './sharedPropTypes';
const DraggableWindow = React.memo(({ theme, onClose, onBackClick, title, children, windowStyle={} }) => {//children used for content sections and windowStyle used for custom style overrides
    const { isNoiseOn, setIsNoiseOn, playSwitchSound } = useSound();
  
    const closeIconDay = require('../static/images/xDay.webp');
    const closeIconDayH = require('../static/images/xDay-h.webp');
    const closeIconNight = require('../static/images/xNight.webp');
    const closeIconNightH = require('../static/images/xNight-h.webp');
    //Window frame images
    const windowFrameDay = require('../static/images/assetComponents/window/day.png');
    const windowFrameNight = require('../static/images/assetComponents/window/night.png');

    const closeIcon = theme === 'light' ? 
    { normal: closeIconDay, hover: closeIconDayH } : 
    { normal: closeIconNight, hover: closeIconNightH };
    
    const [isHoveringClose, setIsHoveringClose] = React.useState(false);
    
    const nodeRef = useRef(null); //ref for draggable component

    const handleClose = useCallback(() => {
      playSwitchSound();
        onClose();
    }, [onClose]);

    const handleBack = useCallback(() => {
      playSwitchSound();  
      onBackClick && onBackClick();
    }, [onBackClick]);
    console.log('Window frame images:', {
      day: windowFrameDay,
      night: windowFrameNight
    });
    //adjust title size and format depending on length and page:
    useEffect(() => {
      const titleElement = nodeRef.current?.querySelector('.titleContainer h1');
      if (titleElement) {
        const titleHeight = titleElement.offsetHeight;
        nodeRef.current.style.setProperty('--title-height', `${titleHeight}px`);
      }
      console.log('DraggableWindow mounted with title:', title);
      return () => console.log('DraggableWindow unmounted with title:', title);
    }, [title]);
  return (
    <Draggable 
      handle=".window-header"
      nodeRef={nodeRef}
      bounds="parent" //Prevent dragging outside viewport
      defaultClassNameDragging="dragging" //Add class during drag
      cancel=".titleContainer, .backBtn, .closeBtn" //Don't drag when clicking these
    >
      <div
        ref={nodeRef} 
        className='refFormat'
        style={{
          backgroundImage:`url(${theme === 'light' ? windowFrameDay : windowFrameNight})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'transparent',
          padding: '0',
          willChange: 'transform',
          ...windowStyle
        }}
      >
        <div className="window-header">
          <div className='headerBtns'></div>
            {onBackClick && (
                <BackButton 
                    theme={theme} 
                    onBack={handleBack}
                    className="backBtn"
                />
            )}{/* Only render BackButton if onBackClick is provided */}
            <button 
              onClick={handleClose}
              className='closeBtn'
              onMouseEnter={() => setIsHoveringClose(true)}
              onMouseLeave={() => setIsHoveringClose(false)}
              style={{
                position: 'absolute',
                top: '30px',
                right: '40px'
            }}
            >
              <img 
                src={isHoveringClose ? closeIcon.hover : closeIcon.normal} 
                alt="Close window" 
                className='closeBtnImage'
                draggable='false'//prevent image dragging
              />
            </button>
          <div className="titleContainer" style={{
              position: 'absolute',
              top: '110px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 'auto',
              maxWidth: '80%'
            }}
          >
              <h1>{title}</h1>
          </div>
        </div>
        <div className="windowContent" style={{
                    position: 'absolute',
                    top: '180px',
                    left: '60px',
                    right: '60px',
                    bottom: '60px',
                    overflowY: 'auto',
                    padding: '10px'
          }}
        >
          {children}
        </div>
      </div>
    </Draggable>
  );
});

DraggableWindow.propTypes = {
  theme: themePropType, //Using shared prop type
  onClose: PropTypes.func.isRequired,
  onBackClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  windowStyle: PropTypes.object
};

export default DraggableWindow;
